import React from 'react';
import { LucideIcon } from 'lucide-react';

interface ToolPageHeaderProps {
  icon: LucideIcon;
  title: string;
  description: string;
  className?: string;
}

export const ToolPageHeader: React.FC<ToolPageHeaderProps> = ({
  icon: Icon,
  title,
  description,
  className = '',
}) => {
  return (
    <div className={`mb-6 lg:mb-8 ${className}`}>
      <div className="flex items-center space-x-3 mb-4">
        <div className="w-8 h-8 sm:w-10 sm:h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
        </div>
        <div>
          <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold tracking-tight">
            {title}
          </h1>
          <p className="text-sm sm:text-base lg:text-lg text-muted-foreground">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};
